/*
 * Public API Surface of ngx-mat-facet-toolkit
 */

export * from './lib/ngx-mat-facet-toolkit.component';
export * from './lib/models';
export * from './lib/facet-toolkit.config';
